<template>
  <div class="card">
    <div class="d-flex align-center mb-6">
        <v-btn icon @click="$emit('back')" class="mr-1"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <h2 class="">Редактирование опросника</h2>
    </div>
    <div class="row mb-4">
      <div class="col-sm-8">
        <v-text-field v-model="instrument.name" label="Заголовок опросника:" dense hide-details class="mb-4" @input="debouncedChanged"/>
        <v-textarea label="Описание" v-model="instrument.description" no-resize hide-details rows="2" @input="debouncedChanged"/>
      </div>

    <!-- {{instrument}} -->
      <div class="col-sm-4">
        <v-btn class="mt-5 w-100" color="primary" @click="showDomainsDialog=true"> Редактировать домены </v-btn>
        <v-btn class="mt-6 w-100" color="primary" @click="showRanksDialog=true"> Редактировать ранги ответов </v-btn>
      </div>
    </div>
    <div class="row mb-4 justify-end">
      <div class="col-sm-4 ">
        <v-btn class="mt-5 w-100 " color="primary" @click="editDomainOverall">
          <v-icon>mdi-pencil-outline</v-icon> Домен общего результата
        </v-btn>
      </div>

    </div>

    <div class="items-list-wrapper">
      <transition-group class="items-list w-100" name="list-complete" tag="div">
        <div v-if="!instrument.direct_questions || !instrument.direct_questions.length" class="mb-4" :key="-1">Добавьте вопросы</div>
        <div v-else class="mb-4" :key="-3">Вопросы:</div>
        <div class="row row-complete-item item-question" v-for="(question, ind) in instrument.direct_questions" :key="question.id">
          <div class="col col-test-name d-flex">
            <div class="mr-2 mt-4 text-gray">{{ ind+1 }}.</div>
            <div class="question-text mt-4 text-container-limit" v-html="getQuestionText(question)"> </div>
          </div>
          <div class="col col-buttons-2 pl-0 pr-1">
            <v-text-field label="Порядок" outlined dense v-model="question.order" hide-details @input="debouncedQuestionChanged(question)" />
          </div>
          <div class="col col-buttons-2 text-right">
            <v-btn icon color="primary" @click="editItem(question)" :disabled="!$store.getters['auth/isAllowed']('change_question')">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="askDelete(question)" :loading="loading.del===question.id" :disabled="!$store.getters['auth/isAllowed']('delete_question')">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="row row-complete-item" :key="-2">
          <v-menu offset-y transition="scale-transition" :disabled="!$store.getters['auth/isAllowed']('add_question')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="add-button" fab dark small color="primary" v-bind="attrs" v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
            </template>
            <v-list>
              <v-list-item link v-for="(item, index) in menuAddQuestion" :key="index">
                <v-list-item-title @click="addItem(item)">{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </transition-group>
    </div>
    <AskDialog v-model="showAskDeleteDialog" @ok="delQuestion(curQuestion)" />
    <QuestionDialog v-model="showEditQuestionDialog" v-if="instrument.direct_questions && curQuestion" :question="curQuestion" />
    <EditDomainsDialog v-model="showDomainsDialog" :instrument="instrument"/>
    <EditRanksDialog v-model="showRanksDialog" :instrument="instrument"/>
    <EditDomainOverallDialog v-model="showEditOverallDialog" :instrument="instrument" />

  </div>
</template>

<script>
/* eslint-disable */
import { debounce } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { Q_TYPES_NAMES } from '@/components/testEditor/QuestionTypes.js';
import AskDialog from '@/components/ui/AskDialog';
import QuestionDialog from '@/components/testEditor/questionDialog/QuestionDialog.vue';
import EditDomainsDialog from '@/components/testEditor/domains/EditDomainsDialog.vue';
import EditRanksDialog from '@/components/testEditor/domains/EditRanksDialog.vue';
import EditDomainOverallDialog from '@/components/testEditor/domains/EditDomainOverallDialog.vue';

export default {
  components: {
    EditDomainOverallDialog,
    AskDialog, QuestionDialog, EditDomainsDialog, EditRanksDialog
  },
  props: {
    instrument: Object,
  },
  data() {
    return {
      showAskDeleteDialog: false,
      showEditQuestionDialog: false,
      showDomainsDialog: false,
      showRanksDialog: false,
      curQuestion: null,
      showEditOverallDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      loading: 'testEditor/loading',
      domains: 'testEditor/domains/domains',
    }),
    menuAddQuestion() {
      return Q_TYPES_NAMES.filter(q => q.showInAddMenuDomain)
    },
  },
  methods: {
    ...mapActions({
      saveInstrument: 'testEditor/saveInstrument',
      addQuestion: 'testEditor/addQuestion',
      loadQuestion: 'testEditor/loadQuestion',
      delQuestion: 'testEditor/delQuestion',
      saveQuestion: 'testEditor/saveQuestion',
    }),
    getQuestionText(question) {
      return /*question.text.length > 510 ? question.text.substring(0, 510)+'...' : */ question.text
    },
    async addItem(item) {
      await this.addQuestion({
        instrument: this.instrument,
        type: item.type,
        newTemplate: item.newTemplate,
      })
    },
    askDelete(item) {
      this.showAskDeleteDialog = true
      this.curQuestion = item
    },
    async editItem(item) {
      this.curQuestion = await this.loadQuestion(item)
      this.showEditQuestionDialog = true
    },
    onChange() {
      this.saveInstrument(this.instrument)
    },
    debouncedChanged: debounce(function (val) {
      this.onChange();
    }, 500),
    debouncedQuestionChanged: debounce(function (question) {
      this.saveQuestion(question);
    }, 500),
    async editDomainOverall() {
      console.log('aaaaa');
      this.showEditOverallDialog = true
    },
  }

}
</script>

<style>
.text-container-limit {
  max-height: 170px; /* Ограничение высоты */
  overflow: hidden; /* Скрытие переполненного текста */
  position: relative; /* Относительное позиционирование для наложения градиента */
}
.text-container-limit::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, transparent, #F9FBFC 200px);
  pointer-events: none; /* Отключение взаимодействия с элементом */
  z-index: 1;
}

</style>
